(function($, window) {

    let darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');    
    
    darkModeMediaQuery.addListener(handleDarkmode);
    handleDarkmode(darkModeMediaQuery);

    function handleDarkmode(e) {
        
        let darkModeOn = e.matches;     // True if dark mode is enabled
        const favicon = $('head link[rel=icon]');
        let iconHref = favicon.attr('href');

        // Modify faviocn source if required
        if (darkModeOn) {
            favicon.attr('href', iconHref.replace('favicon.ico', 'favicon-dark-mode.ico'));
        } else {
            favicon.attr('href', iconHref.replace('favicon-dark-mode.ico', 'favicon.ico'));
        }
    }

})(jQuery, window);
